import { MapPin, HelpCircle, Headphones, CheckCircle2 } from "lucide-react";

const steps = [
    { icon: MapPin, title: "Enter your ZIP code", blurb: "We check if your area is supported before anything else." },
    { icon: HelpCircle, title: "Tell us your situation", blurb: "Moving, renting, business, renewing - one quick question." },
    { icon: Headphones, title: "Talk to a real person", blurb: "We help you review available plans and contract terms." },
    { icon: CheckCircle2, title: "Decide on your own time", blurb: "No pressure. You pick what fits your household or shop." },
];

export default function HowItWorks() {
    return (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16" data-testid="how-it-works">
            <span className="chip">How it works</span>
            <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-white max-w-2xl">
                Four steps. Less than a minute to start.
            </h2>
            <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                {steps.map((s, i) => (
                    <div
                        key={s.title}
                        className="card-surface p-6 reveal"
                        style={{ animationDelay: `${i * 80}ms` }}
                    >
                        <div className="flex items-center gap-3">
                            <span className="w-10 h-10 rounded-xl bg-emerald-500/15 border border-emerald-500/35 inline-flex items-center justify-center text-emerald-300">
                                <s.icon className="w-5 h-5" />
                            </span>
                            <span className="mono text-xs text-slate-500">STEP {i + 1}</span>
                        </div>
                        <h3 className="mt-4 text-lg font-semibold text-white">{s.title}</h3>
                        <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.blurb}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
